import React, { Component } from 'react';
import { withRouter } from 'react-router-dom'
import { graphql, compose } from 'react-apollo'
import gql from 'graphql-tag'
import './App.css';
import { Button, Modal, Image, Grid, Popup, Icon } from 'semantic-ui-react'

import UserFullname from './users/UserFullname'
import UserAvatar from './users/UserAvatar'
import OrganisationLogo from './organisations/OrganisationLogo'
import OrganisationName from './organisations/OrganisationName'

import { BASE_CDN_URL, APP_URL } from './helper/constants'
import {Helmet} from "react-helmet";
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  PinterestShareButton,
  TumblrShareButton,

  FacebookIcon,
  TwitterIcon,  
  LinkedinIcon,
  PinterestIcon,  
  TumblrIcon  
} from 'react-share';

class DiscoveryItemCard extends Component {
  static propTypes = { 
  } 
  state = { 
    likes: 0,
    views: 0,
    canLike: true
  } 

  componentDidMount(){
    if(
      this.props.match.params.id
    ){
      this.props.boardliketotalQuery.refetch({
        boardid: this.props.match.params.id
      }).then((res) => res.data && res.data.boardliketotal ? this.setState({ likes: res.data.boardliketotal })  : null ).catch()

      this.props.discoveryViewTotalQuery.refetch({
        boardid: this.props.match.params.id
      }).then((res) => res.data && res.data.discoveryViewTotal ? this.setState({ views: res.data.discoveryViewTotal })  : null ).catch()

      this.setState({ 
        canLike: true
      })      

      this.props.viewDiscoveryItem({
        variables:{
          boardid: this.props.match.params.id
        }
      })
    }
  }

  componentWillReceiveProps(nextProps){  


    if(
      nextProps.match.params.id 
    ){
      
      //nothing
     
    }else{

      if(
        (
          nextProps.item.boardid && !this.props.item.boardid
        ) ||
        (
          nextProps.item.boardid !== this.props.item.boardid
        ) ||
        (
          !this.props.item.boardid && nextProps.item.boardid
        ) 
      ){      
        this.setState({
          canLike: true
        })

        if(nextProps.item.boardid){
          this.props.boardliketotalQuery.refetch({
            boardid: nextProps.item.boardid
          }).then((res) => res.data && res.data.boardliketotal ? this.setState({ likes: res.data.boardliketotal })  : null ).catch()
        }
        
        if(nextProps.item.boardid){
          this.props.discoveryViewTotalQuery.refetch({
            boardid: nextProps.item.boardid
          }).then((res) => res.data && res.data.discoveryViewTotal ? this.setState({ views: res.data.discoveryViewTotal })  : null ).catch()
        }

        if(nextProps.item.boardid){
          this.props.viewDiscoveryItem({
            variables:{
              boardid: nextProps.item.boardid
            }
          })
        }         
      }

    }


    
    
  }

  like = () =>{
    this.setState({
      likes: this.state.likes+1,
      canLike: false
    })
    this.props.likeBoard({
        variables:{
            boardid: this.props.item.boardid
        }
    }).then((reply)=>{
        if(
            reply.data.likeBoard.error &&
            reply.data.likeBoard.error !== ''
        ){
            alert(reply.data.likeBoard.error)
        }
        if(reply.data.likeBoard.message==='Liked already'){
          this.setState({
            likes: this.state.likes > 0 ? this.state.likes-1 : 0
          })
        }
    })
  } 
  
  unlike = () =>{
    this.setState({
      likes: this.state.likes > 0 ? this.state.likes-1 : 0,
      canLike: true
    })
    this.props.unlikeBoard({
        variables:{
            boardid: this.props.item.boardid
        }
    }).then((reply)=>{
        if(
            reply.data.unlikeBoard.error &&
            reply.data.unlikeBoard.error !== ''
        ){
            alert(reply.data.unlikeBoard.error)
        }       
    })
  } 

  render = () => {
    const item = this.props.item ? this.props.item : {}
    const url = window.location.href
    const imageurl = BASE_CDN_URL+ '/' + item.boardid + '/public/screen.jpg'
    return (
        
        <Modal
            open={
                this.props.parent ?
                this.props.parent.state.modalOpen
                : true
            }
            onClose={
                this.props.parent ?
                this.props.parent.handleClose
                : false
            }
        >
          <Helmet>
            <title>{item.title+' | BrikL Discovery'}</title>
            <meta property="og:image" content={imageurl} /> 
            <meta property="og:title" content={item.title+' | BrikL Discovery'} />
            {/* <meta name="description" content="Helmet application" /> */}

        </Helmet>
          
           
            <Modal.Header className="modalHeader">
              <Grid fluid>
                <Grid.Column width={8}>
                  <Button basic onClick={()=>{
                      if(this.props.parent){
                        this.props.parent.handleClose()
                      }else{
                        this.props.history.push('/')
                      }
                    }                      
                    } floated="left">
                    <Icon name="arrow left"/>
                    Back
                  </Button>
                </Grid.Column>
                <Grid.Column width={8}>
                <Popup
                    trigger={<Button onClick={()=>{
                      window.open(APP_URL+'/discovery/copy/board/'+item.boardid+'?referal=discovery&discoveryitem='+item.boardid)
                    }} floated="right"><Icon name="external" />BrikL</Button>}
                    position='bottom right'
                    >
                    <p>Click here to open the designs in BrikL's fashion Design Studio. </p>

                    <p>Unleash your creativity: Customise the designs and share back on BrikL Discovery.</p>
  
                    <p>Get your design made: Connect directly with the manufacturer through BrikL.</p>
  
                    <p>BrikL is a B2B Collaborative Fashion Design Platform.</p>
                    </Popup>
                    </Grid.Column>
              </Grid>
              <Grid fluid>
                <Grid.Column className="content" computer={11} tablet={7} mobile={16}>                
                 
                  {
                    item.ownedby.indexOf('auth') !== -1 ?
                    <div>
                      <UserFullname className="user--name" userid={item.ownedby} /><UserAvatar className="user--profile__img" userid={item.ownedby} />
                    </div>
                    :
                    <div>
                      <OrganisationLogo className="user--profile__img" organisationid={item.ownedby} />{item.title}<br/> <p>by <OrganisationName className="user--name" organisationid={item.ownedby} /></p>
                    </div>
                  }
                   
                  
                  
                </Grid.Column>

                  <Grid.Column computer={5} tablet={8} mobile={16} className="social--links">
                    <Grid>
                      <Grid.Column computer={16} mobile={16} className="social--links__rows">
                        <Grid>
                          <Grid.Column computer={2} tablet={2} mobile={2}>
                            {
                              this.state.canLike===true ?
                              <Icon name="heart" onClick={()=>{
                                this.like()
                              }}/>
                              :
                              <Icon name="heart" onClick={()=>{
                                this.unlike()
                              }} style={{
                                color: 'red'
                              }} />
                            } 
                             
                          </Grid.Column>
                          <Grid.Column computer={3} tablet={2} mobile={1}>
                            {
                              this.state.canLike===true ?
                              <span onClick={
                                ()=>{
                                  this.like()
                                }
                              }>Like? </span>
                              :
                              <span onClick={
                                ()=>{
                                  this.unlike()
                                }
                              }>Liked</span>                              
                            }                            
                          </Grid.Column>
                          <Grid.Column computer={10} mobile={12}>
                            {
                              this.state.likes + ' likes'
                            }                            
                          </Grid.Column>
                        </Grid>
                      </Grid.Column>
                      <Grid.Column computer={16} mobile={16} className="social--links__rows">
                        <Grid>
                        
                          <Grid.Column computer={2} tablet={2} mobile={2}>
                            <Popup
                              on='click'
                              position="bottom left"
                              className="social--popup"
                              trigger={
                                <Icon name="share" />
                              }>
                            <div className="popup--social__links">
                              <FacebookShareButton url={url} hashtag="#brikl">
                                <FacebookIcon size={32} round />
                              </FacebookShareButton>

                              <TwitterShareButton url={url} title={item.title+' on BrikL Discovery'} hashtags={['brikl']}>
                                <TwitterIcon size={32} round />
                              </TwitterShareButton>
                              <PinterestShareButton url={url} media={imageurl} description={item.title+' on BrikL Discovery'}>
                                <PinterestIcon size={32} round />
                              </PinterestShareButton>
                              <LinkedinShareButton url={url} title={item.title+' on BrikL Discovery'}>
                                <LinkedinIcon size={32} round />
                              </LinkedinShareButton>
                              <TumblrShareButton url={url} title={item.title+' on BrikL Discovery'} tags={['brikl']}>
                                <TumblrIcon size={32} round />
                              </TumblrShareButton>
                              {/* 
                              <Icon name="facebook f"/>
                              <Icon name="twitter"/>
                              <Icon name="pinterest"/>
                              <Icon name="linkedin"/>
                              <Icon name="tumblr"/> */}
                            </div>
                        </Popup>
                          </Grid.Column>
                        
                          <Grid.Column computer={3} tablet={2} mobile={1}>
                            Share
                          </Grid.Column>
                          <Grid.Column computer={10} mobile={12}>
                          {this.state.views} views
                          </Grid.Column>
                          </Grid>
                      </Grid.Column>
                    </Grid>
                  </Grid.Column>

                </Grid>
            </Modal.Header>

            <Modal.Content className="modal--info__details">
            <Grid>
              <Grid.Column computer={11} tablet={10} mobile={16} className="preview--img">
              <Image wrapped src={imageurl} />
              </Grid.Column>
              <Grid.Column computer={5} tablet={6} mobile={16}>
              <Modal.Description>
                <h3>Designer</h3>
                <Grid>
                  <Grid.Column width={16}>
                    {item.suppliers}
                  </Grid.Column>
                </Grid>
                <h3>Colors</h3>
                <Grid>
                <Grid.Column width={16}>
                    {item.colors}
                </Grid.Column>
                </Grid>
                <h3>Categories</h3>
                <Grid>
                <Grid.Column width={16}>
                    {item.category}
                </Grid.Column>
                </Grid>
              </Modal.Description>
              </Grid.Column>
            </Grid>
            </Modal.Content>
            <Modal.Actions>
              
              
            </Modal.Actions>
          
      </Modal>
    );
  }
}

const boardliketotal = gql`
query boardliketotal(
  $boardid: String!
  ){
    boardliketotal(
    boardid: $boardid    
  )
}`
const likeBoard = gql`mutation likeBoard(
  $boardid : String!
  ){
    likeBoard(
      boardid: $boardid,
  ){
      message,
      error,
  }
}`
const unlikeBoard = gql`mutation unlikeBoard(
  $boardid : String!
  ){
    unlikeBoard(
      boardid: $boardid,
  ){
      message,
      error,
  }
}`

const viewDiscoveryItem = gql`mutation viewDiscoveryItem(
  $boardid : String!
  ){
    viewDiscoveryItem(
      boardid: $boardid,
  ){
      message,
      error,
  }
}`

const discoveryViewTotal = gql`
query discoveryViewTotal(
  $boardid: String!
  ){
    discoveryViewTotal(
    boardid: $boardid    
  )
}`

const DiscoveryItemCardWithData = compose(
  graphql(
    boardliketotal, {
     name: 'boardliketotalQuery',
     options: (ownProps) => ({
       variables: {},
       operation: 'query',
     })
   }
 ),
 graphql(
  discoveryViewTotal, {
   name: 'discoveryViewTotalQuery',
   options: (ownProps) => ({
    variables: {},
     operation: 'query',
   })
 }
),
 graphql(
  likeBoard, {
      name: 'likeBoard',
      options: {
          operation: 'mutation',
      }
  }
), 
graphql(
  unlikeBoard, {
      name: 'unlikeBoard',
      options: {
          operation: 'mutation',
      }
  }
), 
graphql(
  viewDiscoveryItem, {
      name: 'viewDiscoveryItem',
      options: {
          operation: 'mutation',
      }
  }
), 
 )(withRouter(DiscoveryItemCard))

export default DiscoveryItemCardWithData



// WEBPACK FOOTER //
// ./src/DiscoveryItemCard.js